export default `
#print {
font-size:14px;

}

    #print .print-order-item-info  {
      border-radius: 0px;
      height:auto;
      max-height:100%;
    }
    #print .print-customer-order-table td:not([class^="print-order-item-info"]) {
      padding: 0!important;
    }

    #print .print-order-shop td:not([class^="print-order-item-info"]) {
      padding: 1px 0!important;
    }
    #print .logo {
      max-width: 50px;
      max-height: 50px;
    }
    
    
    
    
    
    
    #print .pagebreak {
      clear: both;
      page-break-after: always;
    }
    #print .print-order {
      padding: 0 !important;
    }
    #print .print-order .print-order-item-info > div {
      display: block !important;
    }
    #print .print-order .print-order-item-info span , #print .print-order .print-customer-order-table thead , #print .print-order .print-customer-order-table tbody{
      font-size: 14px;
    }
    #print .print-order-btn {
      display: none !important;
    }
    
    #print .bg-title {
      background: #000 !important;
      vertical-align: middle !important;
    }
    #print .print-order-item-call {

    }
    #print .print-order .print-customer-order-table td{
      padding: 0 4px !important;
    }
    /** #print table {
      border: solid #000 !important;
      border-width: 1px!important;
    }
    #print th, #print td {
      border: solid #000 !important;
      border-width: 0 1px 1px 0 !important;
    } */
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    /*! CSS Used from: Embedded */
#print *,*::before,*::after{box-sizing:border-box;}
#print section{display:block;}
#print p{margin-top:0;margin-bottom:1rem;}
#print th{text-align:inherit;text-align:-webkit-match-parent;}
#print button{border-radius:0;}
#print button:focus:not(:focus-visible){outline:0;}
#print button{margin:0;font-family:inherit;font-size:inherit;line-height:inherit;}
#print button{overflow:visible;}
#print button{text-transform:none;}
#print button{-webkit-appearance:button;}
#print button::-moz-focus-inner{padding:0;border-style:none;}
#print .table{width:100%;margin-bottom:1rem;color:#212529;}
#print .table th,.table td{padding:1px 2px;vertical-align:top;}
#print .table thead th{vertical-align:bottom;border-bottom:2px solid #040404;}
#print .table-bordered{border:1px solid #040404;}
#print .table-bordered th,.table-bordered td{border:1px solid #040404;}
#print .table-bordered thead th{border-bottom-width:2px;}
#print .table-responsive{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;}
#print .table-responsive > .table-bordered{border:0;}
#print .btn{display:inline-block;font-weight:400;color:#212529;text-align:center;vertical-align:middle;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:transparent;border:1px solid transparent;
padding:1px 2px;
  font-size:14px;line-height:1.5;border-radius:0.25rem;transition:color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;}
#print.d-flex{display:flex!important;}
#print .flex-column{flex-direction:column!important;}
#print .justify-content-end{justify-content:flex-end!important;}
#print .align-items-center{align-items:center!important;}
#print .mx-0{margin-right:0!important;}
#print .mb-0{margin-bottom:0!important;}
#print .mx-0{margin-left:0!important;}
#print .mr-1{margin-right:0.25rem!important;}
#print .mt-2{margin-top:0.5rem!important;}
#print .mb-4{margin-bottom:1.5rem!important;}
#print .p-1{padding:0.25rem!important;}
#print .pr-1{padding-right:0.25rem!important;}
#print .pt-2,.py-2{padding-top:0.5rem!important;}
#print .pr-2,.px-2{padding-right:0.5rem!important;}
#print .py-2{padding-bottom:0.5rem!important;}
#print .pl-2,.px-2{padding-left:0.5rem!important;}
#print .py-3{padding-top:1rem!important;}
#print .px-3{padding-right:1rem!important;}
#print .py-3{padding-bottom:1rem!important;}
#print .px-3{padding-left:1rem!important;}
#print .px-4{padding-right:1.5rem!important;}
#print .px-4{padding-left:1.5rem!important;}
@media (min-width: 992px){
#print .pb-lg-1{padding-bottom:0.25rem!important;}
}
#print .text-right{text-align:right!important;}
#print .text-center{text-align:center!important;}
#print .font-weight-bold{font-weight:700!important;}
#print .text-white{color:#fff!important;}
#print .table-responsive{margin-bottom:1rem;}
#print .table-responsive > .table{margin-bottom:0;}
#print .btn{font-size:14px;}
#print .table-bordered,.table-bordered th,.table-bordered td{text-align:center;}
/*! CSS Used from: Embedded */
#print *,::after,::before{box-sizing:border-box;}
#print section{display:block;}
#print p{margin-top:0;margin-bottom:1rem;}
#print th{text-align:inherit;text-align:-webkit-match-parent;}
#print button{border-radius:0;}
#print button:focus:not(:focus-visible){outline:0;}
#print button{margin:0;font-family:inherit;font-size:inherit;line-height:inherit;}
#print button{overflow:visible;}
#print button{text-transform:none;}
#print button{-webkit-appearance:button;}
#print button::-moz-focus-inner{padding:0;border-style:none;}
#print .table{width:100%;margin-bottom:1rem;color:#212529;}
#print .table td,.table th{padding:1px 2px;vertical-align:top;}
#print .table thead th{vertical-align:bottom;border-bottom:2px solid #040404;}
#print .table-bordered{border:1px solid #040404;}
#print .table-bordered td,.table-bordered th{border:1px solid #040404;}
#print .table-bordered thead th{border-bottom-width:2px;}
#print .table-responsive{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;}
#print .table-responsive>.table-bordered{border:0;}
#print .btn{display:inline-block;font-weight:400;color:#212529;text-align:center;vertical-align:middle;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:transparent;border:1px solid transparent;padding:.375rem .75rem;
font-size:14px;line-height:1.5;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;}
#print .btn:hover{color:#212529;text-decoration:none;}
#print .btn:focus{outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.25);}
#print .btn:disabled{opacity:.65;}
#print .d-flex{display:flex!important;}
#print .flex-column{flex-direction:column!important;}
#print .justify-content-end{justify-content:flex-end!important;}
#print .align-items-center{align-items:center!important;}
#print .mx-0{margin-right:0!important;}
#print .mb-0{margin-bottom:0!important;}
#print .mx-0{margin-left:0!important;}
#print .mr-1{margin-right:.25rem!important;}
#print .mt-2{margin-top:.5rem!important;}
#print .mb-4{margin-bottom:1.5rem!important;}
#print .p-1{padding:.25rem!important;}
#print .pr-1{padding-right:.25rem!important;}
#print .pt-2,.py-2{padding-top:.5rem!important;}
#print .pr-2,.px-2{padding-right:.5rem!important;}
#print .py-2{padding-bottom:.5rem!important;}
#print .pl-2,.px-2{padding-left:.5rem!important;}
#print .py-3{padding-top:1rem!important;}
#print .px-3{padding-right:1rem!important;}
#print .py-3{padding-bottom:1rem!important;}
#print .px-3{padding-left:1rem!important;}
#print .px-4{padding-right:1.5rem!important;}
#print .px-4{padding-left:1.5rem!important;}
@media (min-width:992px){
#print .pb-lg-1{padding-bottom:.25rem!important;}
}
#print .text-right{text-align:right!important;}
#print .text-center{text-align:center!important;}
#print .font-weight-bold{font-weight:700!important;}
#print .text-white{color:#fff!important;}
#print *{padding:0px;margin:0PX;border:none;font-family:'yekan-bakh', tahoma;direction:rtl;}

#print .print-order-item-title{background:#ddd;vertical-align:middle!important;position:relative;width:100px;
height:60px;}
#print .print-order-item-title > span{background:#ddd;width:100%;height:100%;line-height:55px;display:inline-block;font-weight:bold;padding:5px;}
#print .print-order-item-call{border-right:1px solid #040403;vertical-align:middle!important;
width:160px;
}
#print .print-order .print-customer-order-table thead th{border:1px solid #040403;text-align:center;}
#print .print-order .print-customer-order-table .table-bordered td{border:1px solid #040403!important;}
#print .print-order .print-customer-order-table tbody td{font-size:14px!important;vertical-align:middle;}
#print .print-order .print-order-shop td{padding:0!important;}
#print .print-order .print-order-total-table td{border:1px solid #040403;padding:1px 3px!important;}
#print .print-order .print-customer-table td{border:1px solid #040403!important;}
#print .print-order .btn-print{background-color:#040403;}
@media screen and (max-width: 1020px){
#print .print-order .print-order-item-info span{font-size:14px!important;}
}
@media screen and (max-width: 900px){
#print .print-order .print-order-item-info .print-order-item-address{display:block!important;}
}

    #print .print-customer-order-table th:first-child {
      padding-right:11px!important;

    }
    .print-customer-order-table th {
      background: #dddddd;
    }
    .print-customer-order-table tr td:first-child {
      background: #dddddd;
    }
    #print .print-order-total-table td:nth-child(2) {
      text-align: center!important;
    }
    #print .print-order .print-order-shop .print-order-item-info{padding-bottom:0!important;padding-right:8px!important;
     
    }

#print tr {
  page-break-inside: avoid!important;
}

#print td {
  page-break-inside: avoid;
  page-break-after: avoid;
}

#print thead img { page-break-inside: auto !important; }

#print .print-order-item-title > span:first-child {
    line-height: 15px!important;
    padding-bottom: 0;
}

#print .print-order-item-title:first-child {
    height: 35px;
}
`
